/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'

export const INDUSTRIAL_RESOURCE_TITLE = (
    <FormattedMessage
        id='clan_panel.buyin.industrial_resource.title'
        defaultMessage='Промресурс для вашего клана'
    />
)

export const INDUSTRIAL_RESOURCE_MESSAGE = (
    <FormattedMessage
        id='clan_panel.buyin.industrial_resource.message'
        // eslint-disable-next-line max-len
        defaultMessage='Пополнение запаса промресурса позволит вашему клану быстрее развиться, модернизируя строения Укрепрайона и подготавливая различные клановые резервы.'
    />
)



// WEBPACK FOOTER //
// ./containers/ClanPanel/components/IndustrialBuyinTooltip/constants.jsx